class DigitalInsuranceCardInformation {
  constructor(params) {
    this.customerNumber = params.customerNumber;
    this.uzoviCode = params.uzoviCode;
    this.uzoviDescription = params.uzoviDescription;
    this.hasEHIC = params.hasEHIC;
    this.ehic = params.ehic;
    this.insuranceCard = params.insuranceCard;
  }
}
export { DigitalInsuranceCardInformation as default };
